/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestSolvV2BondManualPriceOracle extends Contract<ITestSolvV2BondManualPriceOracle> {
  setPrice: Send<(_base: AddressLike, _anchor: AddressLike, _timestamp: BigNumberish, _price: BigNumberish) => void, ITestSolvV2BondManualPriceOracle>
  'setPrice(address,address,uint64,int256)': Send<(_base: AddressLike, _anchor: AddressLike, _timestamp: BigNumberish, _price: BigNumberish) => void, ITestSolvV2BondManualPriceOracle>
}

let ITestSolvV2BondManualPriceOracleBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestSolvV2BondManualPriceOracleBytecode = '0x';
}

// prettier-ignore
export const ITestSolvV2BondManualPriceOracle = contract<ITestSolvV2BondManualPriceOracle>(ITestSolvV2BondManualPriceOracleBytecode)`
  function setPrice(address _base, address _anchor, uint64 _timestamp, int256 _price)
`;